var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"control_2"},[_c('div',{directives:[{name:"bg",rawName:"v-bg"}],staticClass:"img-wrapper",attrs:{"bg-url":require("@/auto/assets/image/2/1.png")}}),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"font_box"},[_c('h3',[_vm._v("为全天候使用的")]),_c('h3',[_vm._v("AR 系统设计")])])
}]

export { render, staticRenderFns }